export class LogUserData {
    public userID: string;
    public firstName: string;
    public lastName: string;
    public email: string;
    public roles: string[];
}
